/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import { DropdownField, InputField, RadioField, TextAreaField } from 'Modules/Formik';
import Space from 'Modules/Space/Space';
import { Field, Form, Formik } from 'formik';
import { arrayOf, func, objectOf } from 'prop-types';
import React, { forwardRef, useEffect, useState } from 'react';
import { Icon, Placeholder } from 'semantic-ui-react';
import useGetDoctors from 'Hooks/doctor/useGetDoctors';
import { debounce } from 'lodash';
import useRecentDoctors from 'Hooks/doctor/useRecentDoctors';
import { useSelector } from 'react-redux';
import useClinicDetail from 'Containers/Home/hooks/useClinicDetail';

import css from './ReferralForm.less';
import { ReferralFormSchema } from './validate';

const genOptionClinic = (clinics, value) =>
  clinics?.map(({ id, name, address }) => ({
    key: id,
    value: id,
    text: name,
    content: (
      <div className={css.itemDropdown}>
        <div className={css.info}>
          <div className={css.title}>{name}</div>
          <div className={css.meta}>{address}</div>
        </div>
        {id === value && (
          <div className={css.check}>
            <Icon name="check" />
          </div>
        )}
      </div>
    ),
  }));

const genOptionDoctor = (specialist, value) => {
  return specialist?.map(({ id, name, doctorTitle, avatar, avatarUrl, fullName, title }) => ({
    key: id,
    value: id,
    text: fullName || name,
    content: (
      <div className={css.itemDropdown}>
        <div className={css.item}>
          <div
            className={css.avatar}
            style={{
              backgroundImage: `url(${
                avatar?.thumbPath || avatarUrl || require('Assets/images/commons/default-dr.svg')
              })`,
            }}
          />
          <div className={css.info}>
            <div className={css.title}>{name || fullName}</div>
            <div className={css.meta}>{doctorTitle?.title || title || ''}</div>
          </div>
        </div>
        {id === value && (
          <div className={css.check}>
            <Icon name="check" />
          </div>
        )}
      </div>
    ),
  }));
};

const ReferralForm = forwardRef(({ initialValues, handleGetToClinicsOfDoctor, clinicsTo }, ref) => {
  const [listDoctor, setListDoctor] = useState([]);
  const [searchText, setSeachText] = useState('');
  const { doctors, getDoctors, loading } = useGetDoctors();
  const doctorId = useSelector(state => state.auth.data.accountId);
  const { recentDoctors, getRecentDoctors } = useRecentDoctors();

  const { fromClinicId } = initialValues;
  const { clinicDetail } = useClinicDetail(fromClinicId);

  const onSearch = debounce(event => {
    const searchTerm = event.target.value;
    setSeachText(searchTerm);
    if (searchTerm) {
      getDoctors({ searchTerm, page: 1, pageSize: 99 });
    } else {
      setListDoctor(recentDoctors);
    }
  }, 500);

  useEffect(() => {
    if (
      initialValues.toDoctorId &&
      doctors.find(doctor => doctor.id === initialValues.toDoctorId)
    ) {
      setListDoctor(doctors);
    } else if (initialValues.toDoctorId) {
      setListDoctor(recentDoctors);
    }
  }, [doctors, initialValues.toDoctorId, recentDoctors]);

  const onFocus = event => {
    const searchTerm = event.target.value;
    if (!searchTerm) {
      setListDoctor(recentDoctors);
    }
  };

  useEffect(() => {
    setListDoctor(doctors);
  }, [doctors]);

  useEffect(() => {
    getRecentDoctors(doctorId);
  }, [doctorId, getRecentDoctors]);

  const handleResetDataWhenChangeDoctor = (setFieldValue, value) => {
    if (value) {
      handleGetToClinicsOfDoctor(value);
    } else {
      setListDoctor(recentDoctors);
    }
    setFieldValue('toClinicId', '');
    setSeachText('');
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={() => true}
      validationSchema={ReferralFormSchema}
      innerRef={ref}>
      {({ handleSubmit, values, setFieldValue }) => (
        <Form onSubmit={handleSubmit}>
          <div className={css.referralForm}>
            <div className={css.referralCol}>
              <Space size={6}>
                <h3 style={{ margin: 0 }}>Referral From</h3>
                <div>Clinic: {clinicDetail?.name}</div>
              </Space>
            </div>
            <div className={css.referralCol}>
              <Space size={12}>
                <Space size={4}>
                  <h3 style={{ margin: 0 }}>Referral To</h3>
                  <Space direction="horizontal" justify="space-between" alignItems="center">
                    Refer within MaNaDr network
                    <Field name="referToManaDr" toggle component={RadioField} />
                  </Space>
                </Space>
                {values.referToManaDr ? (
                  <Space size={16}>
                    <div className={css.toDoctor}>
                      <Field
                        label="Specialist"
                        name="toDoctorId"
                        component={DropdownField}
                        search
                        errorInline
                        options={genOptionDoctor(listDoctor, values.toDoctorId)}
                        onSearchChange={onSearch}
                        placeholder="Please select specialist"
                        loading={loading}
                        clearable
                        onChange={(name, value) =>
                          handleResetDataWhenChangeDoctor(setFieldValue, value)
                        }
                        onFocus={onFocus}
                        header={
                          loading ? (
                            <Placeholder>
                              <Placeholder.Header image>
                                <Placeholder.Line />
                                <Placeholder.Line />
                              </Placeholder.Header>
                            </Placeholder>
                          ) : !loading && !searchText ? (
                            <div className={css.title}>Recently refer</div>
                          ) : (
                            <div className={css.result}>
                              {doctors?.length
                                ? `${doctors?.length} results found`
                                : 'No results found'}
                            </div>
                          )
                        }
                      />
                    </div>
                    <Field
                      label="Clinic (optional) "
                      name="toClinicId"
                      component={DropdownField}
                      clearable
                      options={genOptionClinic(clinicsTo, values.toClinicId)}
                      placeholder="Please select clinic"
                    />
                  </Space>
                ) : (
                  <Space>
                    <Field
                      label="Specialist Information"
                      name="specialistInfo"
                      component={TextAreaField}
                      placeholder="Dr John Doe&#10;Healthmark Clinic&#10;+65 12345678&#10;470 Jurong West St"
                      rows={4}
                      errorInline
                    />
                    <Space size={8}>
                      <Field
                        label="Specialist Email (optional)"
                        name="specialistEmail"
                        component={InputField}
                        placeholder="Enter specialist email"
                        style={{ width: '100%' }}
                      />
                      <span style={{ fontSize: 10, color: '#6A7882' }}>
                        To notify specialist about referral
                      </span>
                    </Space>
                  </Space>
                )}
              </Space>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
});

ReferralForm.propTypes = {
  initialValues: objectOf({}).isRequired,
  clinicsTo: arrayOf({}).isRequired,
  handleGetToClinicsOfDoctor: func.isRequired,
};

export default ReferralForm;
